import { IProvider, PROVIDER_STATUS_LIST } from 'model/v2';
import { MapProviderPetAllergies } from 'utils/common';
// loadedAssistants: the assistants the form fetched separately. The provider
// query does not return them, so without this a reset() empties the field.
export const mapProviderFormDefaultValues = (
  provider?: IProvider,
  loadedAssistants?: any[]
) => {
  if (!provider) return {};
  const {
    status,
    displayName,
    appointmentTypes,
    providerCapacity,
    isObservable,
    telehealthLinks,
    assistantsInput,
    allowSelfScheduling,
    petAllergies,
    gender,
    address,
    corticaPrograms,
    pendingTermination,
    endDate
  } = provider;

  return {
    ...provider,
    // keeps the Display Name input controlled for providers without one
    displayName: displayName ?? '',
    capacity:
      status === PROVIDER_STATUS_LIST.TERMINATED ||
      status === PROVIDER_STATUS_LIST.LEAVE_OF_ABSENCE
        ? 0
        : providerCapacity?.capacity,
    status: status ? status : PROVIDER_STATUS_LIST.ACTIVE,
    isObservable: isObservable ? isObservable : false,
    appointmentTypes: appointmentTypes?.map(item => item.id),
    rampingPercentage: providerCapacity?.rampingPercentage,
    assistantsInput: loadedAssistants ?? assistantsInput?.map(item => item),
    allowSelfScheduling: allowSelfScheduling ? 1 : 0,
    telehealthLinks: telehealthLinks,
    petAllergies: petAllergies
      ? MapProviderPetAllergies(petAllergies)
      : undefined,
    gender: gender,
    addressLine1: address?.addressLine1,
    addressLine2: address?.addressLine2 ? address?.addressLine2 : '',
    addressId: address?.id,
    city: address?.city,
    state: address?.state ? address?.state : undefined,
    zipCode: address?.zipCode,
    corticaPrograms: corticaPrograms?.map(item => item.id),
    pendingTermination: pendingTermination || false,
    endDate: endDate ? new Date(endDate).toISOString().split('T')[0] : null
  };
};
